import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { useApp } from "@/context/AppContext";
import { Globe, Volume2, Wand2 } from "lucide-react";

export const SettingsDialog = ({ open, onOpenChange }) => {
  const { t, lang, setLang, settings, setSetting } = useApp();

  const Row = ({ icon, label, children, testid }) => (
    <div
      data-testid={testid}
      className="flex items-center justify-between gap-4 py-3 border-b-2 border-dashed border-ink/15 last:border-0"
    >
      <div className="flex items-center gap-3">
        <span className="grid place-items-center w-9 h-9 rounded-md bg-cream border-2 border-ink">
          {icon}
        </span>
        <span className="font-display font-bold text-sm">{label}</span>
      </div>
      {children}
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="settings-dialog"
        className="border-2 border-ink shadow-brutal-lg bg-cream rounded-xl max-w-sm"
      >
        <DialogHeader>
          <DialogTitle className="font-display font-black text-2xl tracking-tight">
            {t("settings")}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t("brand")} — {t("settings")}
          </DialogDescription>
        </DialogHeader>

        <div className="mt-1">
          <Row icon={<Globe className="w-4 h-4" strokeWidth={2.5} />} label={t("language")} testid="setting-language">
            <div className="flex rounded-md border-2 border-ink overflow-hidden">
              {["tr", "en"].map((l) => (
                <button
                  key={l}
                  data-testid={`lang-option-${l}`}
                  onClick={() => setLang(l)}
                  className={`px-3 py-1.5 text-xs font-black font-display transition-colors ${
                    lang === l ? "bg-ink text-cream" : "bg-white text-ink"
                  }`}
                >
                  {l === "tr" ? t("turkish") : t("english")}
                </button>
              ))}
            </div>
          </Row>

          <Row icon={<Volume2 className="w-4 h-4" strokeWidth={2.5} />} label={t("sound")} testid="setting-sound">
            <Switch
              data-testid="sound-switch"
              checked={settings.sound}
              onCheckedChange={(v) => setSetting("sound", v)}
            />
          </Row>

          <Row icon={<Wand2 className="w-4 h-4" strokeWidth={2.5} />} label={t("animations")} testid="setting-animations">
            <Switch
              data-testid="animations-switch"
              checked={settings.animations}
              onCheckedChange={(v) => setSetting("animations", v)}
            />
          </Row>
        </div>
      </DialogContent>
    </Dialog>
  );
};
